import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchRecentUpdateData } from "./homeAPI";
export interface RecentUpdatesState {
  recentUpdatesData: Array<any>;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: RecentUpdatesState = {
  recentUpdatesData: [],
  status: "idle",
};

export const GetRecentUpdatesData = createAsyncThunk("recentUpdates/fetchRecentUpdateData", async (data:any) => {
  const response = await fetchRecentUpdateData(data);
  return response;
});

export const recentUpdatesSlice = createSlice({
  name: "recentUpdates",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetRecentUpdatesData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetRecentUpdatesData.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetRecentUpdatesData.fulfilled, (state, action) => {
        state.status = "success";
       // state.recentUpdatesData = action.payload.ethicsPolicy;
       state.recentUpdatesData = state.recentUpdatesData.concat(action.payload.ethicsPolicy);
      });
  },
});

export const {} = recentUpdatesSlice.actions;

export const selectRecentUpdatesData = (state: RootState) => {
  return state.recentUpdates.recentUpdatesData;
};

export default recentUpdatesSlice.reducer;
